import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { IAumyeState } from '../states/aumye.state';
import * as fromAnalyticsActions from '../actions/analytics.actions';
import * as fromDashboardActions from '../actions/dashboard.action';
import { tap, withLatestFrom, switchMap, mergeMap, catchError, of } from 'rxjs';
import { AumyeAnalyticsService } from 'src/app/services/aumye-analytics.service';
import { MatDialog } from '@angular/material/dialog';
import { IAnalyticsData } from 'src/app/services/simulation/aumyeSim.utils';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Injectable()
export class AnalyticsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IAumyeState>,
    private router: Router,
    private toastr: ToastrService,
    private aumyeAnalyticsService: AumyeAnalyticsService,
    private dialog: MatDialog,
    private encryptionService: EncryptionService
  ) {}
  InitAnalyticsTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.InitAnalyticsTab>(
          fromAnalyticsActions.AnalyticsActionTypes.INIT_ANALYTICS_DATA
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          this.router.navigateByUrl('dashboard/analytics');
          let orgid = this.encryptionService.getCurrentUser().organizationID;
          if (orgid != '766773b7-51e9-4951-a2de-6245e6233758') {
            this.store.dispatch(
              new fromAnalyticsActions.GetRiskProfileQuestions({})
            );
            this.store.dispatch(
              new fromAnalyticsActions.GetVisitorAnalytics({})
            );
          }
        })
      ),
    { dispatch: false }
  );
  CreateVisitorTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.CreateVisitorTicket>(
        fromAnalyticsActions.AnalyticsActionTypes.CREATE_VISITOR_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        let {
          action: { payload },
        } = data;
        return this.aumyeAnalyticsService.onCreateVisitorTicket(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromAnalyticsActions.CreateVisitorTicketSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.CreateVisitorTicketFailed(err))
          )
        );
      })
    )
  );
  CreateVisitorTicketSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.CreateVisitorTicketSuccess>(
          fromAnalyticsActions.AnalyticsActionTypes
            .CREATE_VISITOR_TICKET_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // //this.toastr.success('Create Visitor Ticket Success');
          this.store.dispatch(new fromAnalyticsActions.GetVisitorTickets({}));
        })
      ),
    { dispatch: false }
  );
  CreateVisitorTicketFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.CreateVisitorTicketFailed>(
          fromAnalyticsActions.AnalyticsActionTypes
            .CREATE_VISITOR_TICKET_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          this.toastr.error('Create Visitor Ticket Failed');
        })
      ),
    { dispatch: false }
  );

  CreateIncidentTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.CreateIncidentTicket>(
        fromAnalyticsActions.AnalyticsActionTypes.CREATE_INCIDENT_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        let {
          action: { payload },
        } = data;
        return this.aumyeAnalyticsService.onCreateIncidentTicket(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromAnalyticsActions.CreateIncidentTicketSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.CreateVisitorTicketFailed(err))
          )
        );
      })
    )
  );
  CreateIncidentTicketSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.CreateIncidentTicketSuccess>(
          fromAnalyticsActions.AnalyticsActionTypes
            .CREATE_INCIDENT_TICKET_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // //this.toastr.success('Create Incident Ticket Success');
          this.store.dispatch(new fromAnalyticsActions.GetIncidentTickets({}));
        })
      ),
    { dispatch: false }
  );
  CreateIncidentTicketFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.CreateIncidentTicketFailed>(
          fromAnalyticsActions.AnalyticsActionTypes
            .CREATE_INCIDENT_TICKET_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          this.toastr.error('Create Incident Ticket Failed');
        })
      ),
    { dispatch: false }
  );
  GetVisitorTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.GetVisitorTickets>(
        fromAnalyticsActions.AnalyticsActionTypes.GET_VISITOR_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.aumyeAnalyticsService.onGetVisitorTickets().pipe(
          mergeMap((res: any) => {
            return of(new fromAnalyticsActions.GetVisitorTicketsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.GetVisitorTicketsFailed(err))
          )
        );
      })
    )
  );
  GetRiskProfileQuestions$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.GetRiskProfileQuestions>(
        fromAnalyticsActions.AnalyticsActionTypes.GET_RISK_PROFILE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.aumyeAnalyticsService.onGetRiskProfileQuestions().pipe(
          mergeMap((res: any) => {
            return of(
              new fromAnalyticsActions.GetRiskProfileQuestionsSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.GetRiskProfileQuestionsFailed(err))
          )
        );
      })
    )
  );
  GetRiskProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.GetRiskProfileQuestions>(
        fromAnalyticsActions.AnalyticsActionTypes.GET_RISK_PROFILE_NEW
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.aumyeAnalyticsService.onGetRiskProfileNew().pipe(
          mergeMap((res: any) => {
            return of(
              new fromAnalyticsActions.GetRiskProfileNewSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.GetRiskProfileNewFailed(err))
          )
        );
      })
    )
  );
  GetVisitorAnalytics$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.GetVisitorAnalytics>(
        fromAnalyticsActions.AnalyticsActionTypes.GET_VISITOR_ANALYTICS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.aumyeAnalyticsService.onGetVisitorAnalytics().pipe(
          mergeMap((res: any) => {
            return of(new fromAnalyticsActions.GetVisitorAnalyticsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.GetVisitorAnalyticsFailed(err))
          )
        );
      })
    )
  );

  GetVisitorTicketsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetVisitorTicketsSuccess>(
          fromAnalyticsActions.AnalyticsActionTypes.GET_VISITOR_TICKET_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // //this.toastr.success('Get Visitor Ticket Success');
        })
      ),
    { dispatch: false }
  );
  GetVisitorTicketsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetVisitorTicketsFailed>(
          fromAnalyticsActions.AnalyticsActionTypes.GET_VISITOR_TICKET_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // this.toastr.error('Get Visitor Ticket Failed');
        })
      ),
    { dispatch: false }
  );
  GetIncidentTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.GetIncidentTickets>(
        fromAnalyticsActions.AnalyticsActionTypes.GET_INCIDENT_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.aumyeAnalyticsService.onGetIncidentTickets().pipe(
          mergeMap((res: any) => {
            return of(new fromAnalyticsActions.GetIncidentTicketsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.GetIncidentTicketsFailed(err))
          )
        );
      })
    )
  );
  GetIncidentTicketsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetIncidentTicketsSuccess>(
          fromAnalyticsActions.AnalyticsActionTypes.GET_INCIDENT_TICKET_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // //this.toastr.success('Get Incident Ticket Success');
        })
      ),
    { dispatch: false }
  );
  GetIncidentTicketsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetIncidentTicketsFailed>(
          fromAnalyticsActions.AnalyticsActionTypes.GET_INCIDENT_TICKET_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // this.toastr.error('Get Incident Ticket Failed');
        })
      ),
    { dispatch: false }
  );
  GetComplaintsTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.GetComplaintsTickets>(
        fromAnalyticsActions.AnalyticsActionTypes.GET_COMPLAINTS_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.aumyeAnalyticsService.onGetComplaintsTickets().pipe(
          mergeMap((res: any) => {
            return of(
              new fromAnalyticsActions.GetComplaintsTicketsSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.GetComplaintsTicketsFailed(err))
          )
        );
      })
    )
  );
  GetComplaintsTicketsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetComplaintsTicketsSuccess>(
          fromAnalyticsActions.AnalyticsActionTypes
            .GET_COMPLAINTS_TICKET_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // //this.toastr.success('Get Complaints Ticket Success');
        })
      ),
    { dispatch: false }
  );
  GetComplaintsTicketsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetComplaintsTicketsFailed>(
          fromAnalyticsActions.AnalyticsActionTypes
            .GET_COMPLAINTS_TICKET_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // this.toastr.error('Get Complaints Ticket Failed');
        })
      ),
    { dispatch: false }
  );
  //Claims
  GetClaimTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.GetClaimTickets>(
        fromAnalyticsActions.AnalyticsActionTypes.GET_CLAIM_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.aumyeAnalyticsService.onGetClaimTickets().pipe(
          mergeMap((res: any) => {
            return of(new fromAnalyticsActions.GetClaimTicketsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.GetClaimTicketsFailed(err))
          )
        );
      })
    )
  );
  GetClaimTicketsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetClaimTicketsSuccess>(
          fromAnalyticsActions.AnalyticsActionTypes.GET_CLAIM_TICKET_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // //this.toastr.success('Get Complaints Ticket Success');
        })
      ),
    { dispatch: false }
  );
  GetClaimTicketsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetClaimTicketsFailed>(
          fromAnalyticsActions.AnalyticsActionTypes.GET_CLAIM_TICKET_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // this.toastr.error('Get Complaints Ticket Failed');
        })
      ),
    { dispatch: false }
  );
  //Requests
  GetRequestsTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.GetRequestsTickets>(
        fromAnalyticsActions.AnalyticsActionTypes.GET_REQUESTS_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.aumyeAnalyticsService.onGetRequestTickets().pipe(
          mergeMap((res: any) => {
            return of(new fromAnalyticsActions.GetRequestsTicketsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromAnalyticsActions.GetRequestsTicketsFailed(err))
          )
        );
      })
    )
  );
  GetRequestsTicketsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetRequestsTicketsSuccess>(
          fromAnalyticsActions.AnalyticsActionTypes.GET_REQUESTS_TICKET_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // //this.toastr.success('Get Complaints Ticket Success');
        })
      ),
    { dispatch: false }
  );
  GetRequestsTicketsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.GetRequestsTicketsFailed>(
          fromAnalyticsActions.AnalyticsActionTypes.GET_REQUESTS_TICKET_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          // this.toastr.error('Get Complaints Ticket Failed');
        })
      ),
    { dispatch: false }
  );

  SaveRiskProfileQuestions$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromAnalyticsActions.SaveRiskProfileQuestions>(
        fromAnalyticsActions.AnalyticsActionTypes.SAVE_RISK_PROFILE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.aumyeAnalyticsService
          .onSaveRiskProfileQuestions(JSON.stringify(payload))
          .pipe(
            mergeMap((res: any) => {
              return of(
                new fromAnalyticsActions.SaveRiskProfileQuestionsSuccess(res)
              );
            }),
            catchError((err: any) =>
              of(new fromAnalyticsActions.SaveRiskProfileQuestionsFailed(err))
            )
          );
      })
    )
  );
  SaveRiskProfileSimQuestions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.SaveRiskProfileSimQuestions>(
          fromAnalyticsActions.AnalyticsActionTypes.SAVE_RISK_PROFILE_SIM
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          this.dialog.closeAll();
          this.toastr.success('Saved!', 'Analytics Questions', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          setTimeout(() => {
            this.store.dispatch(new fromDashboardActions.InitDashboardSim({}));
          }, 2000);

          // this.store.dispatch(new fromAnalyticsActions.CreateAnalyticsData({}));
        })
      ),
    { dispatch: false }
  );
  CreateAnalyticsData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.CreateAnalyticsData>(
          fromAnalyticsActions.AnalyticsActionTypes.CREATE_ANALYTICS_DATA
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(({ state: { riskQuestions } }) => {
          let analyticsData: IAnalyticsData;
          // analyticsData ={
          //   riskQuestions :riskQuestions,

          // }
        })
      ),
    { dispatch: false }
  );
  SaveRiskProfileQuestionsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.SaveRiskProfileQuestionsSuccess>(
          fromAnalyticsActions.AnalyticsActionTypes.SAVE_RISK_PROFILE_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          this.dialog.closeAll();
          this.toastr.success('Saved!', 'Analytics Questions', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
  SaveRiskProfileQuestionsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromAnalyticsActions.SaveRiskProfileQuestionsFailed>(
          fromAnalyticsActions.AnalyticsActionTypes.SAVE_RISK_PROFILE_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAnalyticsState,
          action: action,
        })),
        tap(() => {
          this.toastr.error('Thats an Error!');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
}
